export default __webpack_public_path__ + "static/media/home-page-header.f0f6b731.png";